import { gql } from "@apollo/client";
import * as Sentry from "@sentry/react";
import { useCreateInviteKeyMutation } from "src/gql/codegen/graphql";
import { Team } from "../InviteMemberDialog";
import { Session } from "src/utils/users/types";
import { useState } from "react";

export function useTeamInviteLink(team: Team, session: Session) {
  const [inviteLink, setInviteLink] = useState<string | undefined>(undefined);
  const [callCreateInviteKeyMutation] = useCreateInviteKeyMutation();

  function createInviteLink(): string | undefined {
    callCreateInviteKeyMutation({
      context: { session },
      variables: {
        team_id: team.id,
      },
    })
      .then((res) => {
        if (res.data && res.data.create_invite_key) {
          const key = res.data.create_invite_key.id;
          const link = `https://dune.com/t/${team.handle}/${key}`;
          setInviteLink(link);
        }
      })
      .catch((error) => {
        Sentry.captureException(
          `Could not create invite link for team ${team.id}: ${error}`
        );
        return undefined;
      });
    return undefined;
  }

  return [inviteLink, createInviteLink] as const;
}

gql`
  mutation CreateInviteKey($team_id: Int!) {
    create_invite_key(team_id: $team_id) {
      id
    }
  }
`;
